$(function () {
var owl = $(".owl-carousel.listing-collection");
  owl.owlCarousel({
      autoplay: false,
      dots: true,
      loop: true,
      nav: true,
      margin: 20,
      responsive: {
      0: {
          items: 1,
      },
      768: {
          items: 2,
      },
      1200: {
          items: 3,
      },
    },
  });
});
function postsCarousel() {
  var checkWidth = $(window).width();
  var owlPost = $(".inner-production-sec ");
  if (checkWidth > 992) {
    if (typeof owlPost.data('owl.carousel') != 'undefined') {
      owlPost.data('owl.carousel').destroy();
    }
    owlPost.removeClass('owl-carousel');
  } else if (checkWidth < 993) {
    owlPost.addClass('owl-carousel');
    owlPost.owlCarousel({
      items: 1,
      touchDrag: true,
      mouseDrag: true,
      autoplay: true,
      dots: true,
      loop: true, 
      responsive: {
        0: {
            items: 1,
        },
        768: {
            items: 2,
        },
      },
    });
  }
}
postsCarousel();
$(window).resize(postsCarousel);